/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";

import MDProgress from "components/MDProgress";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import Grid from "@mui/material/Grid";

function PlatformSettings({ eventStatiquesDetails }) {
  return (
    <Card sx={{ boxShadow: "none", width: "100%" }}>
      <MDBox p={2}>
        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
          Détails
        </MDTypography>
      </MDBox>
      <MDBox pt={1} pb={2} px={2} lineHeight={1.25}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <MDTypography
              variant="body2"
              color="text"
              sx={{ fontWeight: 500, fontSize: "0.8rem", mb: 1 }}
            >
              Progression des tickets ({eventStatiquesDetails?.numberOfSellTickets}/
              {eventStatiquesDetails?.sumOfTickets})
            </MDTypography>
            <MDProgress
              value={
                (eventStatiquesDetails?.numberOfSellTickets / eventStatiquesDetails?.sumOfTickets) *
                100
              }
              variant="gradient"
            />

            <MDTypography
              variant="body2"
              color="text"
              sx={{ fontWeight: 500, fontSize: "0.8rem", mt: 4, mb: 1 }}
            >
              Taux de remplissage ({eventStatiquesDetails?.numberOfUsedTickets}/
              {eventStatiquesDetails?.sumOfTickets})
            </MDTypography>
            <MDProgress
              value={
                (eventStatiquesDetails?.numberOfUsedTickets / eventStatiquesDetails?.sumOfTickets) *
                100
              }
              variant="gradient"
            />
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}

export default PlatformSettings;
